import React from 'react';

import { createStyles, Group, Text } from '@mantine/core';
import { IconChevronUp, IconChevronDown, IconSelector } from '@tabler/icons-react';

const useStyles = createStyles(
  (theme, { isSortable, bgc }: { isSortable: boolean; bgc: 'white' | 'gray' }) => ({
    th: {
      '&:hover': {
        backgroundColor: isSortable ? theme.colors.gray[0] : 'default',
      },
      cursor: isSortable ? 'pointer !important' : 'default !important',
      background: bgc === 'white' ? theme.white : theme.colors.gray[0],
    },

    text: {
      fontSize: theme.fontSizes.sm,
      color: theme.colors.gray[6],
      fontWeight: 600,
    },

    sticky: {
      position: 'sticky',
      right: 0,
      background: bgc === 'white' ? theme.white : theme.colors.gray[0],
    },
  }),
);

interface ThProps {
  columnId: string;
  isSortable: boolean;
  ordering: string;
  ascending: boolean;
  handleHeaderClick: (data: any) => void;
  bgc?: 'white' | 'gray';
  sticky?: boolean;
  children: React.ReactNode;
}

const Th = ({
  columnId,
  isSortable,
  ordering,
  ascending,
  handleHeaderClick,
  sticky = false,
  bgc = 'white',
  children,
}: ThProps & any): JSX.Element => {
  const { classes, theme } = useStyles({ isSortable, bgc });

  const isSortedBy = columnId === ordering;

  let Icon;
  if (ascending) {
    Icon = IconChevronDown;
  } else {
    Icon = IconChevronUp;
  }

  const handleClick = (): void => {
    if (isSortable) {
      handleHeaderClick(columnId);
    }
  };

  return (
    <th className={`${classes.th} ${sticky ? classes.sticky : ''}`} onClick={handleClick}>
      <Group spacing={4} noWrap align='center'>
        <Text className={classes.text}>{children}</Text>
        {isSortable && !isSortedBy && (
          <IconSelector size={theme.fontSizes.md} color={theme.colors.gray[6]} />
        )}
        {isSortable && isSortedBy && <Icon size={theme.fontSizes.md} color={theme.colors.gray[6]} />}
      </Group>
    </th>
  );
};

export default Th;
